import React from 'react'

import T from 'components/FormattedMessage'
import Currency from 'components/Currency'
import ActionContext from 'components/ActionContext'
import InviteFriendsButton from 'components/InviteFriendsButton'

import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import { ReferralsResponse } from 'protos'
import { Action } from 'types'

import PossibleBonusList from './components/PossibleBonusList'
import WonBonusList from './components/WonBonusList'

interface Props {
  getUserReferrals: () => Promise<ReferralsResponse>
}

type State = {
  referrals: Action<ReferralsResponse | null>
  selectedBonusId?: number
}

const styles = (theme: Theme) => createStyles({
  headline: {
    marginBottom: theme.spacing(),
    marginTop: theme.spacing() * 3,
  },
  emptyStateButton: {
    width: 260,
    margin: 'auto',
    display: 'block',
    marginTop: theme.spacing() * 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

class InviteFriendsTab extends React.Component<InjectedProps, State> {
  constructor(props: InjectedProps) {
    super(props)
    this.state = {
      referrals: { isLoading: true },
    }
  }

  componentDidMount() {
    this.requestUserReferrals()
  }

  private selectBonus = (bonusId: number) => {
    this.setState(state => ({ selectedBonusId: state.selectedBonusId === bonusId ? undefined : bonusId }))
  }

  private requestUserReferrals = () => {
    this.props.getUserReferrals()
      .then((result: ReferralsResponse) => {
        this.setState({ referrals: { isLoading: false, result }})
      })
      .catch((err: Error) => {
        this.setState({ referrals: { isLoading: false, errorCode: err.message }})
      })
  }

  private renderContent = () => {
    const { classes } = this.props
    const { result } = this.state.referrals

    if (!result) {
      return null
    }

    const receivedBonus = Number(result.receivedBonus && result.receivedBonus!.value)

    return (
      <>
        <Typography variant="h5" align="center" className={classes.headline}>
          <T id="friends_empty" />
        </Typography>
        <Typography variant="subtitle1" align="center">
          {receivedBonus > 0
            ? (
              <T
                id="referrals_header_message"
                values={{ bonus: <Currency value={receivedBonus} /> }}
              />
            )
            : <T id="referrals_header_empty_message" />
          }
        </Typography>
        <InviteFriendsButton className={classes.emptyStateButton} />
        {result.referredUsers > 0 && (
          <WonBonusList
            bonuses={result.bonus || []}
            onBonusSelect={this.selectBonus}
            selectedBonusId={this.state.selectedBonusId}
          />
        )}
        <PossibleBonusList bonuses={result.bonus || []} />
        <InviteFriendsButton className={classes.emptyStateButton} />
      </>
    )
  }

  render() {
    const { isLoading, errorCode } = this.state.referrals

    return (
      <ActionContext
        isLoading={isLoading}
        errorCode={errorCode}
        component={this.renderContent}
        componentProps={{}}
      />
    )
  }
}

export default withStyles(styles)(InviteFriendsTab)
